export const PRODUCT_NAME = 'Tokenion Lens';

/**
 * Brand wordmark: "Token" in the default text color (navy in light mode), "ion" in primary blue.
 * Both are theme variables, so the split stays legible in dark mode.
 */
export function Tokenion({ className = '' }: { className?: string }) {
  return (
    <span className={`font-bold ${className}`}>
      <span className="text-text-default">Token</span>
      <span className="text-primary-blue">ion</span>
    </span>
  );
}

/** Full product name: the Tokenion wordmark followed by "Lens". */
export function Wordmark({ className = '' }: { className?: string }) {
  return (
    <span className={className}>
      <span className="sr-only">{PRODUCT_NAME}</span>
      <span aria-hidden="true">
        <Tokenion /> <span className="font-bold text-text-default">Lens</span>
      </span>
    </span>
  );
}
